import { Suspense, lazy, useSyncExternalStore } from "react";
import { leadWhatsappStore } from "@/lib/lead-whatsapp";

const LeadWhatsappDialog = lazy(() => import("./LeadWhatsappDialog"));

/** Montado uma vez na raiz; baixa o formulário só quando algum CTA de WhatsApp é clicado. */
export function LeadWhatsappHost() {
  const pedido = useSyncExternalStore(leadWhatsappStore.subscribe, leadWhatsappStore.getSnapshot);
  if (!pedido) return null;
  return (
    <Suspense fallback={null}>
      <LeadWhatsappDialog pedido={pedido} onClose={leadWhatsappStore.fechar} />
    </Suspense>
  );
}
